import { render, staticRenderFns } from "./printHKZLPurchases.vue?vue&type=template&id=46c937b8&scoped=true&"
import script from "./printHKZLPurchases.vue?vue&type=script&lang=js&"
export * from "./printHKZLPurchases.vue?vue&type=script&lang=js&"
import style0 from "./printHKZLPurchases.vue?vue&type=style&index=0&id=46c937b8&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "46c937b8",
  null
  
)

component.options.__file = "printHKZLPurchases.vue"
export default component.exports